/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  InterviewDetail,
  InterviewPreview,
  InterviewSummary,
  LogInterviewRequest,
  LogInterviewResult,
  PreviewInterviewRequest,
  RecentJamieMeeting,
} from "../models/index";
import {
  InterviewDetailFromJSON,
  InterviewDetailToJSON,
  InterviewPreviewFromJSON,
  InterviewPreviewToJSON,
  InterviewSummaryFromJSON,
  InterviewSummaryToJSON,
  LogInterviewRequestFromJSON,
  LogInterviewRequestToJSON,
  LogInterviewResultFromJSON,
  LogInterviewResultToJSON,
  PreviewInterviewRequestFromJSON,
  PreviewInterviewRequestToJSON,
  RecentJamieMeetingFromJSON,
  RecentJamieMeetingToJSON,
} from "../models/index";

export interface GetInterviewRequest {
  applicationInterviewId: string;
}

export interface ListForApplicationRequest {
  applicationId: string;
}

export interface LogInterviewOperationRequest {
  logInterviewRequest: LogInterviewRequest;
}

export interface PreviewInterviewOperationRequest {
  previewInterviewRequest: PreviewInterviewRequest;
}

/**
 *
 */
export class PeopleInterviewsApi extends runtime.BaseAPI {
  /**
   */
  async getInterviewRaw(
    requestParameters: GetInterviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InterviewDetail>> {
    if (requestParameters["applicationInterviewId"] == null) {
      throw new runtime.RequiredError(
        "applicationInterviewId",
        'Required parameter "applicationInterviewId" was null or undefined when calling getInterview().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/interviews/{applicationInterviewId}`.replace(
          `{${"applicationInterviewId"}}`,
          encodeURIComponent(
            String(requestParameters["applicationInterviewId"]),
          ),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InterviewDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getInterview(
    requestParameters: GetInterviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InterviewDetail> {
    const response = await this.getInterviewRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listForApplicationRaw(
    requestParameters: ListForApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<InterviewSummary>>> {
    if (requestParameters["applicationId"] == null) {
      throw new runtime.RequiredError(
        "applicationId",
        'Required parameter "applicationId" was null or undefined when calling listForApplication().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["applicationId"] != null) {
      queryParameters["applicationId"] = requestParameters["applicationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/interviews/for-application`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(InterviewSummaryFromJSON),
    );
  }

  /**
   */
  async listForApplication(
    requestParameters: ListForApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<InterviewSummary>> {
    const response = await this.listForApplicationRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Persist the interview snapshot against the application.
   * Persist the interview snapshot against the application.
   */
  async logInterviewRaw(
    requestParameters: LogInterviewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LogInterviewResult>> {
    if (requestParameters["logInterviewRequest"] == null) {
      throw new runtime.RequiredError(
        "logInterviewRequest",
        'Required parameter "logInterviewRequest" was null or undefined when calling logInterview().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/interviews/log`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogInterviewRequestToJSON(
          requestParameters["logInterviewRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LogInterviewResultFromJSON(jsonValue),
    );
  }

  /**
   * Persist the interview snapshot against the application.
   * Persist the interview snapshot against the application.
   */
  async logInterview(
    requestParameters: LogInterviewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LogInterviewResult> {
    const response = await this.logInterviewRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewInterviewRaw(
    requestParameters: PreviewInterviewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InterviewPreview>> {
    if (requestParameters["previewInterviewRequest"] == null) {
      throw new runtime.RequiredError(
        "previewInterviewRequest",
        'Required parameter "previewInterviewRequest" was null or undefined when calling previewInterview().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/interviews/preview`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PreviewInterviewRequestToJSON(
          requestParameters["previewInterviewRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InterviewPreviewFromJSON(jsonValue),
    );
  }

  /**
   * Fetch + parse one of the current user\'s meetings for review. Does not persist.
   * Fetch + parse one of the current user\'s meetings for review.
   */
  async previewInterview(
    requestParameters: PreviewInterviewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InterviewPreview> {
    const response = await this.previewInterviewRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentInterviewMeetingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<RecentJamieMeeting>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/interviews/recent-meetings`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RecentJamieMeetingFromJSON),
    );
  }

  /**
   * The current user\'s recent Jamie meetings, to pick one to log. Scoped to the logged-in user.
   * The current user\'s recent Jamie meetings, to pick one to log.
   */
  async recentInterviewMeetings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<RecentJamieMeeting>> {
    const response = await this.recentInterviewMeetingsRaw(initOverrides);
    return await response.value();
  }
}
